module.exports = __webpack_public_path__ + "b1a607467e026174fa2dd9c3a2e7e11f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/assets/images/lenna.png
 ** module id = 47
 ** module chunks = 0
 **/